import React from 'react';
import styles from './BetTableDragon.module.css';

// Card mapping - API values: 1=A, 2=2, 3=3, ..., 10=10, J=11, Q=12, K=13
const cards = [
  { value: "A", apiValue: "1", imageNum: 1 },
  { value: "2", apiValue: "2", imageNum: 2 },
  { value: "3", apiValue: "3", imageNum: 3 },
  { value: "4", apiValue: "4", imageNum: 4 },
  { value: "5", apiValue: "5", imageNum: 5 },
  { value: "6", apiValue: "6", imageNum: 6 },
  { value: "7", apiValue: "7", imageNum: 7 },
  { value: "8", apiValue: "8", imageNum: 8 },
  { value: "9", apiValue: "9", imageNum: 9 },
  { value: "10", apiValue: "10", imageNum: 10 },
  { value: "J", apiValue: "J", imageNum: 11 },
  { value: "Q", apiValue: "Q", imageNum: 12 },
  { value: "K", apiValue: "K", imageNum: 13 },
];

export default function BetTableDragon({ data = [], exposures = {} }) {
  // Helper function to find bet data by name
  const findBetData = (name) => {
    return data.find((item) => item.nat === name) || { nat: name, b: 0, sid: null, gstatus: "SUSPENDED", min: 100, max: 100000 };
  };

  // Helper function to find card bet data
  const findCardBetData = (side, cardApiValue) => {
    const cardName = `${side} Card ${cardApiValue}`;
    return findBetData(cardName);
  };

  // Get odds from bet data, with fallback
  const getOdds = (betData, fallback) => {
    if (betData?.b !== undefined && betData.b !== null && betData.b !== "" && betData.b !== 0) {
      return betData.b;
    }
    return fallback;
  };

  // Check if bet is suspended
  const isSuspended = (betData) => {
    return betData?.gstatus === "SUSPENDED" || betData?.b === 0;
  };

  // Get exposure value for a bet
  const getExposure = (betName) => {
    const exposureKeys = [
      betName,
      betName?.toLowerCase(),
      betName?.trim(),
    ];

    for (const key of exposureKeys) {
      if (key && exposures[key] !== undefined) {
        return exposures[key];
      }
    }
    return 0;
  };

  // Format min/max values
  const formatLimit = (value) => {
    if (value >= 1000) {
      return `${(value / 1000).toFixed(0)}K`;
    }
    return value.toFixed(0);
  };

  // Top section bets
  const dragonBet = findBetData("Dragon");
  const tieBet = findBetData("Tie");
  const tigerBet = findBetData("Tiger");
  const pairBet = findBetData("Pair");

  const dragonExposure = getExposure("Dragon");
  const tieExposure = getExposure("Tie");
  const tigerExposure = getExposure("Tiger");
  const pairExposure = getExposure("Pair");

  // Dragon section bets
  const dragonEven = findBetData("Dragon Even");
  const dragonOdd = findBetData("Dragon Odd");
  const dragonRed = findBetData("Dragon Red");
  const dragonBlack = findBetData("Dragon Black");

  const dragonEvenExposure = getExposure("Dragon Even");
  const dragonOddExposure = getExposure("Dragon Odd");
  const dragonRedExposure = getExposure("Dragon Red");
  const dragonBlackExposure = getExposure("Dragon Black");

  // Tiger section bets
  const tigerEven = findBetData("Tiger Even");
  const tigerOdd = findBetData("Tiger Odd");
  const tigerRed = findBetData("Tiger Red");
  const tigerBlack = findBetData("Tiger Black");

  const tigerEvenExposure = getExposure("Tiger Even");
  const tigerOddExposure = getExposure("Tiger Odd");
  const tigerRedExposure = getExposure("Tiger Red");
  const tigerBlackExposure = getExposure("Tiger Black");

  // Get card image URL from CDN
  const getCardImageUrl = (imageNum) => {
    return `https://d3kb8xz339pq18.cloudfront.net/v12/static/backend/images/andar_bahar/${imageNum}.jpg`;
  };

  return (
    <div className={`${styles.dtContainer} casino-box`}>
      {/* Top Row: Dragon, Tie, Tiger, Pair */}
      <div className={`${styles.dtBox} ${styles.mb10}`}>
        <div className="row">
          <div className="col-md-9">
            <div className="row">
              <div className="col-md-5 text-center">
                <b>{getOdds(dragonBet, "0")}</b>
                <div className={styles.mt10}>
                  <button className={`text-uppercase ${styles.lowHighBtn} ${isSuspended(dragonBet) ? styles.suspended : ""}`} style={{ position: 'relative' }}>
                    <b>Dragon</b>
                  </button>
                  <span className={`d-block ${styles.mt5}`} style={{ color: dragonExposure !== 0 ? (dragonExposure < 0 ? '#ff0000' : '#00ff00') : 'black' }}>
                    {dragonExposure !== 0 ? (dragonExposure < 0 ? dragonExposure.toFixed(0) : `+${dragonExposure.toFixed(0)}`) : "0"}
                  </span>
                </div>
              </div>
              <div className="col-md-2 text-center">
                <b>{getOdds(tieBet, "0")}</b>
                <div className={styles.mt10}>
                  <button className={`text-uppercase ${styles.lowHighBtn} ${isSuspended(tieBet) ? styles.suspended : ""}`} style={{ position: 'relative' }}>
                    <b>Tie</b>
                  </button>
                  <span className={`d-block ${styles.mt5}`} style={{ color: tieExposure !== 0 ? (tieExposure < 0 ? '#ff0000' : '#00ff00') : 'black' }}>
                    {tieExposure !== 0 ? (tieExposure < 0 ? tieExposure.toFixed(0) : `+${tieExposure.toFixed(0)}`) : "0"}
                  </span>
                </div>
              </div>
              <div className="col-md-5 text-center">
                <b>{getOdds(tigerBet, "0")}</b>
                <div className={styles.mt10}>
                  <button className={`text-uppercase ${styles.lowHighBtn} ${isSuspended(tigerBet) ? styles.suspended : ""}`} style={{ position: 'relative' }}>
                    <b>Tiger</b>
                  </button>
                  <span className={`d-block ${styles.mt5}`} style={{ color: tigerExposure !== 0 ? (tigerExposure < 0 ? '#ff0000' : '#00ff00') : 'black' }}>
                    {tigerExposure !== 0 ? (tigerExposure < 0 ? tigerExposure.toFixed(0) : `+${tigerExposure.toFixed(0)}`) : "0"}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className={`col-md-3 ${styles.pairBlock} text-center`}>
            <b>{getOdds(pairBet, "0")}</b>
            <div className={styles.mt10}>
              <button className={`text-uppercase ${styles.lowHighBtn} ${isSuspended(pairBet) ? styles.suspended : ""}`} style={{ position: 'relative' }}>
                <b>Pair</b>
              </button>
              <span className={`d-block ${styles.mt5}`} style={{ color: pairExposure !== 0 ? (pairExposure < 0 ? '#ff0000' : '#00ff00') : 'black' }}>
                {pairExposure !== 0 ? (pairExposure < 0 ? pairExposure.toFixed(0) : `+${pairExposure.toFixed(0)}`) : "0"}
              </span>
            </div>
          </div>
          <div className={`col-md-12 ${styles.mt10} text-right`}>
            <span className={styles.mr10}>
              <b>Min:</b> <span>{dragonBet?.min ? formatLimit(dragonBet.min) : "100"}</span>
            </span>
            <span>
              <b>Max:</b> <span>{dragonBet?.max ? formatLimit(dragonBet.max) : "100K"}</span>
            </span>
          </div>
        </div>
      </div>

      {/* Dragon and Tiger Sections Side by Side */}
      <div className="row">
        {/* Dragon Section */}
        <div className="col-md-6">
          <div className={`${styles.dtBox} ${styles.mb10}`}>
            <div className="row">
              <div className="col-12">
                <h4 className={`${styles.mb0} text-center text-uppercase`}>Dragon</h4>
              </div>
              <div className="col-md-6 text-center">
                <b>{getOdds(dragonEven, "0")}</b>
                <div className={styles.mt10}>
                  <button className={`text-uppercase ${styles.lowHighBtn} ${isSuspended(dragonEven) ? styles.suspended : ""}`} style={{ position: 'relative' }}>
                    <b>EVEN</b>
                  </button>
                  <span className={`d-block ${styles.mt5}`} style={{ color: dragonEvenExposure !== 0 ? (dragonEvenExposure < 0 ? '#ff0000' : '#00ff00') : 'black' }}>
                    {dragonEvenExposure !== 0 ? (dragonEvenExposure < 0 ? dragonEvenExposure.toFixed(0) : `+${dragonEvenExposure.toFixed(0)}`) : "0"}
                  </span>
                </div>
              </div>
              <div className="col-md-6 text-center">
                <b>{getOdds(dragonOdd, "0")}</b>
                <div className={styles.mt10}>
                  <button className={`text-uppercase ${styles.lowHighBtn} ${isSuspended(dragonOdd) ? styles.suspended : ""}`} style={{ position: 'relative' }}>
                    <b>ODD</b>
                  </button>
                  <span className={`d-block ${styles.mt5}`} style={{ color: dragonOddExposure !== 0 ? (dragonOddExposure < 0 ? '#ff0000' : '#00ff00') : 'black' }}>
                    {dragonOddExposure !== 0 ? (dragonOddExposure < 0 ? dragonOddExposure.toFixed(0) : `+${dragonOddExposure.toFixed(0)}`) : "0"}
                  </span>
                </div>
              </div>
              <div className={`col-md-12 ${styles.mt10} text-right`}>
                <span className={styles.mr10}>
                  <b>Min:</b> <span>{dragonEven?.min ? formatLimit(dragonEven.min) : "100"}</span>
                </span>
                <span>
                  <b>Max:</b> <span>{dragonEven?.max ? formatLimit(dragonEven.max) : "25K"}</span>
                </span>
              </div>
              <div className={`col-md-6 text-center ${styles.mt10}`}>
                <b>{getOdds(dragonRed, "0")}</b>
                <div className={styles.mt10}>
                  <button className={`text-uppercase ${styles.lowHighBtn} ${isSuspended(dragonRed) ? styles.suspended : ""}`} style={{ position: 'relative' }}>
                    <span className={styles.cardIcon}>
                      <span className={styles.cardRed}>[</span>
                    </span>
                    <span className={styles.cardIcon}>
                      <span className={styles.cardRed}>{'{'}</span>
                    </span>
                  </button>
                  <span className={`d-block ${styles.mt5}`} style={{ color: dragonRedExposure !== 0 ? (dragonRedExposure < 0 ? '#ff0000' : '#00ff00') : 'black' }}>
                    {dragonRedExposure !== 0 ? (dragonRedExposure < 0 ? dragonRedExposure.toFixed(0) : `+${dragonRedExposure.toFixed(0)}`) : "0"}
                  </span>
                </div>
              </div>
              <div className="col-md-6 text-center mt-10">
                <b>{getOdds(dragonBlack, "0")}</b>
                <div className={styles.mt10}>
                  <button className={`text-uppercase ${styles.lowHighBtn} ${isSuspended(dragonBlack) ? styles.suspended : ""}`} style={{ position: 'relative' }}>
                    <span className={styles.cardIcon}>
                      <span className={styles.cardBlack}>]</span>
                    </span>
                    <span className={styles.cardIcon}>
                      <span className={styles.cardBlack}>{'}'}</span>
                    </span>
                  </button>
                  <span className={`d-block ${styles.mt5}`} style={{ color: dragonBlackExposure !== 0 ? (dragonBlackExposure < 0 ? '#ff0000' : '#00ff00') : 'black' }}>
                    {dragonBlackExposure !== 0 ? (dragonBlackExposure < 0 ? dragonBlackExposure.toFixed(0) : `+${dragonBlackExposure.toFixed(0)}`) : "0"}
                  </span>
                </div>
              </div>
              <div className={`col-md-12 ${styles.mt10} text-right`}>
                <span className={styles.mr10}>
                  <b>Min:</b> <span>{dragonRed?.min ? formatLimit(dragonRed.min) : "100"}</span>
                </span>
                <span>
                  <b>Max:</b> <span>{dragonRed?.max ? formatLimit(dragonRed.max) : "25K"}</span>
                </span>
              </div>
            </div>
          </div>

          {/* Dragon Cards Section */}
          <div className={`${styles.dtBox} ${styles.mb10}`}>
            <div className="row">
              <div className="col-md-12">
                <h4 className={`${styles.mb0} text-center text-uppercase`}>
                  Dragon {getOdds(findCardBetData("Dragon", "1"), "0")}
                </h4>
              </div>
              <div className={`${styles.cardDt} col-md-12 text-center ${styles.mt10}`}>
                {cards.map((card) => {
                  const cardBet = findCardBetData("Dragon", card.apiValue);
                  const cardExposure = getExposure(`Dragon Card ${card.apiValue}`);
                  return (
                    <div key={`dragon-${card.value}`} className={`${styles.mr5} ${styles.cardImage} d-inline-block`} style={{ position: 'relative' }}>
                      <div className={isSuspended(cardBet) ? styles.suspended : ""}>
                        <img
                          src={getCardImageUrl(card.imageNum)}
                          alt={card.value}
                          onError={(e) => e.target.style.display = 'none'}
                        />
                      </div>
                      <div className={`${styles.ubook} text-center ${styles.mt5}`}>
                        <b>
                          <span style={{ color: cardExposure !== 0 ? (cardExposure < 0 ? '#ff0000' : '#00ff00') : 'black' }}>
                            {cardExposure !== 0 ? (cardExposure < 0 ? cardExposure.toFixed(0) : `+${cardExposure.toFixed(0)}`) : "0"}
                          </span>
                        </b>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className={`col-md-12 ${styles.mt10} text-right`}>
                <span className={styles.mr10}>
                  <b>Min:</b> <span>{(() => {
                    const firstCard = findCardBetData("Dragon", "1");
                    return firstCard?.min ? formatLimit(firstCard.min) : "100";
                  })()}</span>
                </span>
                <span>
                  <b>Max:</b> <span>{(() => {
                    const firstCard = findCardBetData("Dragon", "1");
                    return firstCard?.max ? formatLimit(firstCard.max) : "5K";
                  })()}</span>
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Tiger Section */}
        <div className="col-md-6">
          <div className={`${styles.dtBox} ${styles.mb10}`}>
            <div className="row">
              <div className="col-12">
                <h4 className={`${styles.mb0} text-center text-uppercase`}>Tiger</h4>
              </div>
              <div className="col-md-6 text-center">
                <b>{getOdds(tigerEven, "0")}</b>
                <div className={styles.mt10}>
                  <button className={`text-uppercase ${styles.lowHighBtn} ${isSuspended(tigerEven) ? styles.suspended : ""}`} style={{ position: 'relative' }}>
                    <b>EVEN</b>
                  </button>
                  <span className={`d-block ${styles.mt5}`} style={{ color: tigerEvenExposure !== 0 ? (tigerEvenExposure < 0 ? '#ff0000' : '#00ff00') : 'black' }}>
                    {tigerEvenExposure !== 0 ? (tigerEvenExposure < 0 ? tigerEvenExposure.toFixed(0) : `+${tigerEvenExposure.toFixed(0)}`) : "0"}
                  </span>
                </div>
              </div>
              <div className="col-md-6 text-center">
                <b>{getOdds(tigerOdd, "0")}</b>
                <div className={styles.mt10}>
                  <button className={`text-uppercase ${styles.lowHighBtn} ${isSuspended(tigerOdd) ? styles.suspended : ""}`} style={{ position: 'relative' }}>
                    <b>ODD</b>
                  </button>
                  <span className={`d-block ${styles.mt5}`} style={{ color: tigerOddExposure !== 0 ? (tigerOddExposure < 0 ? '#ff0000' : '#00ff00') : 'black' }}>
                    {tigerOddExposure !== 0 ? (tigerOddExposure < 0 ? tigerOddExposure.toFixed(0) : `+${tigerOddExposure.toFixed(0)}`) : "0"}
                  </span>
                </div>
              </div>
              <div className={`col-md-12 ${styles.mt10} text-right`}>
                <span className={styles.mr10}>
                  <b>Min:</b> <span>{tigerEven?.min ? formatLimit(tigerEven.min) : "100"}</span>
                </span>
                <span>
                  <b>Max:</b> <span>{tigerEven?.max ? formatLimit(tigerEven.max) : "25K"}</span>
                </span>
              </div>
              <div className={`col-md-6 text-center ${styles.mt10}`}>
                <b>{getOdds(tigerRed, "0")}</b>
                <div className={styles.mt10}>
                  <button className={`text-uppercase ${styles.lowHighBtn} ${isSuspended(tigerRed) ? styles.suspended : ""}`} style={{ position: 'relative' }}>
                    <span className={styles.cardIcon}>
                      <span className={styles.cardRed}>[</span>
                    </span>
                    <span className={styles.cardIcon}>
                      <span className={styles.cardRed}>{'{'}</span>
                    </span>
                  </button>
                  <span className={`d-block ${styles.mt5}`} style={{ color: tigerRedExposure !== 0 ? (tigerRedExposure < 0 ? '#ff0000' : '#00ff00') : 'black' }}>
                    {tigerRedExposure !== 0 ? (tigerRedExposure < 0 ? tigerRedExposure.toFixed(0) : `+${tigerRedExposure.toFixed(0)}`) : "0"}
                  </span>
                </div>
              </div>
              <div className="col-md-6 text-center mt-10">
                <b>{getOdds(tigerBlack, "0")}</b>
                <div className={styles.mt10}>
                  <button className={`text-uppercase ${styles.lowHighBtn} ${isSuspended(tigerBlack) ? styles.suspended : ""}`} style={{ position: 'relative' }}>
                    <span className={styles.cardIcon}>
                      <span className={styles.cardBlack}>]</span>
                    </span>
                    <span className={styles.cardIcon}>
                      <span className={styles.cardBlack}>{'}'}</span>
                    </span>
                  </button>
                  <span className={`d-block ${styles.mt5}`} style={{ color: tigerBlackExposure !== 0 ? (tigerBlackExposure < 0 ? '#ff0000' : '#00ff00') : 'black' }}>
                    {tigerBlackExposure !== 0 ? (tigerBlackExposure < 0 ? tigerBlackExposure.toFixed(0) : `+${tigerBlackExposure.toFixed(0)}`) : "0"}
                  </span>
                </div>
              </div>
              <div className={`col-md-12 ${styles.mt10} text-right`}>
                <span className={styles.mr10}>
                  <b>Min:</b> <span>{tigerRed?.min ? formatLimit(tigerRed.min) : "100"}</span>
                </span>
                <span>
                  <b>Max:</b> <span>{tigerRed?.max ? formatLimit(tigerRed.max) : "25K"}</span>
                </span>
              </div>
            </div>
          </div>

          {/* Tiger Cards Section */}
          <div className={`${styles.dtBox} ${styles.mb10}`}>
            <div className="row">
              <div className="col-md-12">
                <h4 className={`${styles.mb0} text-center text-uppercase`}>
                  Tiger {getOdds(findCardBetData("Tiger", "1"), "0")}
                </h4>
              </div>
              <div className={`${styles.cardDt} col-md-12 text-center ${styles.mt10}`}>
                {cards.map((card) => {
                  const cardBet = findCardBetData("Tiger", card.apiValue);
                  const cardExposure = getExposure(`Tiger Card ${card.apiValue}`);
                  return (
                    <div key={`tiger-${card.value}`} className={`${styles.mr5} ${styles.cardImage} d-inline-block`} style={{ position: 'relative' }}>
                      <div className={isSuspended(cardBet) ? styles.suspended : ""}>
                        <img
                          src={getCardImageUrl(card.imageNum)}
                          alt={card.value}
                          onError={(e) => e.target.style.display = 'none'}
                        />
                      </div>
                      <div className={`${styles.ubook} text-center ${styles.mt5}`}>
                        <b>
                          <span style={{ color: cardExposure !== 0 ? (cardExposure < 0 ? '#ff0000' : '#00ff00') : 'black' }}>
                            {cardExposure !== 0 ? (cardExposure < 0 ? cardExposure.toFixed(0) : `+${cardExposure.toFixed(0)}`) : "0"}
                          </span>
                        </b>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="col-md-12 mt-10 text-right">
                <span className={styles.mr10}>
                  <b>Min:</b> <span>{(() => {
                    const firstCard = findCardBetData("Tiger", "1");
                    return firstCard?.min ? formatLimit(firstCard.min) : "100";
                  })()}</span>
                </span>
                <span>
                  <b>Max:</b> <span>{(() => {
                    const firstCard = findCardBetData("Tiger", "1");
                    return firstCard?.max ? formatLimit(firstCard.max) : "5K";
                  })()}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
